import React from "react";
import styles from "../styles/PageLayout.module.css";

export function PageHeader({ title, description, eyebrow = "Admin", actions, sticky = true }) {
  return (
    <header className={sticky ? `${styles.pageHeader} ${styles.pageHeaderSticky}` : styles.pageHeader}>
      <div className={styles.pageHeaderCopy}>
        <div className={styles.pageEyebrow}>{eyebrow}</div>
        <h2 className={styles.pageTitle}>{title}</h2>
        {description ? <p className={styles.pageDescription}>{description}</p> : null}
      </div>
      {actions ? <div className={styles.pageActions}>{actions}</div> : null}
    </header>
  );
}

export default PageHeader;
